import { useEffect, useState } from "react"
import api from "../api-client"
import { toast } from "react-toastify"
import './credit-report.scss'
import { CreditReport, CreditReportType, EquifaxPrequalReport, errorToString } from "@oneethos/shared"
import { Spinner, SpinnerSize } from "@fluentui/react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { CreditReportSummary, EquifaxDitReport, jsonToCreditItem } from "@oneethos/shared"
import { CreditReportTester, Section } from "../components"

type CreditReportsProps = {
  search: URLSearchParams
}

export const CreditReports = ({ search }: CreditReportsProps) => {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const doSearch = (params: URLSearchParams) => {
    setLoading(true)
    api.get(`/credit-reports?${params.toString()}`).then(res => {
      const _list = res.list.map(i => i?.reportType === 'dit' ? { report: i, item: i } : jsonToCreditItem(i))

      setList(_list)
    }).catch(ex => toast.error(errorToString(ex))).finally(() => setLoading(false))
  }

  useEffect(() => {
    const obj = Object.fromEntries(search)
    if (Object.keys(obj).length) {
      doSearch(search)
    }
  }, [search])

  return (
    <div>
      <h4 className="mt-4">Credit Reports</h4>
      <div>
        {loading ? <Spinner size={SpinnerSize.large} /> :
          (list.length === 0 ? <div className="alert alert-secondary">No reports match your search</div> : (
            <div className="list-group">
              {list.map((entry, i) => {
                const isPrequal = [
                  CreditReportType.Prequal,
                  CreditReportType.PrequalCombined,
                  CreditReportType.PrequalCoborrower
                ].includes(entry.item.reportType)

                return <div
                  key={entry.item._id}
                  className="list-group-item list-group-item-action credit-report"
                  style={{ cursor: 'pointer' }}
                >
                  {isPrequal ? (
                    <CreditReportSummary
                      report={entry.report}
                      item={entry.item}
                      onClick={() => navigate(`/prequal-reports/${entry.item._id}`)}
                    />
                  ) : <EquifaxDitReport
                    item={entry.item}
                    onClick={() => window.open(entry.item.secureDocUrl, '_blank')}
                  />}
                </div>
              })}
            </div>
          )
          )}
      </div>
    </div>
  )
}

export const CreditReportsPage = () => {
  const [search, setQuery] = useState('')
  const [params] = useSearchParams()
  const [searchParams, setSearchParams] = useState(params)

  return <div>
    <Section>
      <div className="no-print">
        <h3>Credit Reports</h3>
        <div className="alert alert-info">Prequal reports are deleted after 30 days</div>
        <div className="form-group">
          <label>Search by Name</label>
          <input
            type="text"
            className="form-control"
            value={search}
            onChange={ev => setQuery(ev.target.value)} />
          <div className="text-small">must match first or last name exactly and is case-sensitive</div>
        </div>
        <div className="buttons mb-3">
          <button type="button" className="btn btn-primary" onClick={() => setSearchParams(new URLSearchParams({ search }))}>
            Search
          </button>
        </div>
      </div>

      <CreditReports search={searchParams} />
    </Section>
    <div className="no-print">
      <Section>
        <CreditReportTester />
      </Section>
    </div>
  </div>
}

export default CreditReportsPage